// removed by extract-text-webpack-plugin
module.exports = {"arrangerContainer":"_1_JDM","scene":"_2hzFM","player":"h6atc","inactive":"fU3PI","selected":"_2XNVh","spawner":"Du-Xx","spawnAngle":"_2-Dx_","spawnBreadth":"_1O2gM","arrangerMenu":"RupFn","numberInput":"FH00N"};


//////////////////
// WEBPACK FOOTER
// ./src/components/orchestra/OrchestraArrange.css
// module id = 242
// module chunks = 0